import $ from "jquery";
import Em from "./Em";

class Header extends Em {
	constructor() {
		super();
		this.init();
	}

	init() {
		if (!this.selfDom()) return;

		this.addInverseHeaderClass();
		this.events();
	}

	selfDom() {
		// pull header
		this.$pullHeader = this.$body.find('.header-pull:first');
		this.$headerNavToggle= $('.header-nav-toggle');
		this.$headerNavWrap = this.$header.find('#header-nav-wrap');

		return true;
	}

	events() {
		//nav toggle click
		this.$headerNavToggle.off('click.Header');
		this.$headerNavToggle.on('click.Header', this.navToggleHandler.bind(this));

		//close nav
		this.$window.off('resize.Header');
		this.$window.on('resize.Header', () => {
			if(!this.isMobile()) {
				this.closeNav();
			}
		});
	}

	navCloseHandler(event) {
		event.preventDefault();

		this.closeNav();
	}

	navToggleHandler(event) {
		event.preventDefault();

		if (!this.$body.hasClass('nav-is-active')) {
			this.openNav();
		} else {
			this.closeNav();
		}
	}

	openNav() {
		this.$body.addClass('nav-is-active');
		this.$headerNavToggle.addClass('is-active');
		this.$headerNavWrap.addClass('is-active');

		if(this.$pullHeader.hasClass('header-inverse')) {
			this.$header.removeClass('is-inverse');
		}
	
	}

	closeNav() {
		this.$body.removeClass('nav-is-active');
		this.$headerNavToggle.removeClass('is-active');
		this.$headerNavWrap.removeClass('is-active');

		if(this.$pullHeader.hasClass('header-inverse')) {
			this.$header.addClass('is-inverse');
		}
	}

	addInverseHeaderClass() {
		if (
			this.$pullHeader.length < 1 || 
			!this.$pullHeader.hasClass('header-inverse')
		) return;

		this.$header.addClass('is-inverse');
	}

	isMobile() {
		return this.$header.find(this.$headerNavToggle).is(':visible');
	}
}

export default Header;
